module.exports = __webpack_public_path__ + "static/media/logo.c79a8714.png";